import { render, staticRenderFns } from "./DriverView.vue?vue&type=template&id=68a6fe2e&"
import script from "./DriverView.vue?vue&type=script&lang=js&"
export * from "./DriverView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports